require('./brokerWatchlistModal.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

// @commons
const { ModalCustom } = require('commonsComponents/modalCustom');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const { OKLink } = require('commonsComponents/OKLink');
const { OKInput } = require('commonsComponents/OKInput');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @images
const watchlistIcon = require('assets/images/watchlistStar_icon.svg');

// @constant
const { LIST_NAME_MAX_LENGTH, BROKER_FAVORITE_MAX_PRODUCT_SIZE } = require('constants/index');

class BrokerWatchlistModal extends React.Component {
    constructor(props) {
        super(props);
        this.buildModalContent = this.buildModalContent.bind(this);
        this.createModalForNewList = this.createModalForNewList.bind(this);
        this.createModalForExistingList = this.createModalForExistingList.bind(this);
        this.handleNewListName = this.handleNewListName.bind(this);
        this.handleListSelected = this.handleListSelected.bind(this);
    }

    handleNewListName(e) {
        this.props.saveListName(e.target.value);
    }

    createModalForNewList() {
        const { listName, watchlistContent } = this.props;
        let errorFlag = false;
        watchlistContent.map((content) => {
            if (listName === content.get('name')) {
                errorFlag = true;
            }
        });
        const disabled = (listName.length <= 0 || errorFlag);
        const errorMsg = formatText("brokerWatchList-brokerWatchlist_listErrorMessage",[listName]);
        const instructionsList = [
            'brokerWatchList-brokerWatchList_watchListNameInstruction1',
            'brokerWatchList-brokerWatchList_watchListNameInstruction2',
            'brokerWatchList-brokerWatchList_watchListNameInstruction3',
        ];
        const tooltipInstructions = instructionsList.map((value, index)=>(
            <li key={index} className="watch-list__guide-list-item">
                {formatText(value, [LIST_NAME_MAX_LENGTH])}
            </li>
        ));
        const iconHelpTooltipText = (
            <ul className="watch-list__edit-name-guide-list">
                {tooltipInstructions}
            </ul>
        );
        return (
            <div className="col-xs-12">
                <div className="broker-watchlist-modal__title">
                    <img src={watchlistIcon} className="broker-watchlist-modal__title-icon" />
                    <div>{formatText('brokerWatchList-brokerWatchlist_newListTitle')}</div>
                </div>
                <div className="broker-watchlist-modal__content">
                    <div className="broker-watchlist-modal__content--input">
                        <OKInput
                            value={listName}
                            onChange={this.handleNewListName}
                            maxLength={30}
                            autoComplete="off"
                            errorState={errorFlag}
                            errorMessage={errorMsg}
                            placeholder={formatText('brokerWatchList-brokerWatchlist_emptyStateListName')}
                        />
                        <div className="broker-watchlist-modal__content--tooltip">
                            <OKTooltip
                                content={iconHelpTooltipText}
                                placement="top"
                            />
                        </div>
                    </div>
                </div>
                <div className="broker-watchlist-modal__footer">
                    <div className="row">
                        <div className="col-xs-6">
                            <OKButton onClick={this.props.handleCancelForModal} modifier="link-ghost">
                                {formatText('brokerWatchList-brokerWatchList_cancelButton')}
                            </OKButton>
                        </div>
                        <div className="col-xs-6 text-right">
                            <OKButton onClick={this.props.handleContinueForNewList} disabled={disabled}>
                                {formatText('brokerWatchList-brokerWatchlist_nextButton')}
                            </OKButton>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    handleListSelected(id) {
        this.props.onChangeListSelected(id);
    }

    createModalForExistingList() {
        const { watchlistContent, handleNewListModal, listSelectedId } = this.props;
        const disableLinkClassName = classNames({            
            'broker-watchlist-modal__list--content-link--disabled': watchlistContent.size >= 10
        });
        const radioContent = watchlistContent.map((content) => {
            const id = content.get('id');
            const name = content.get('name');
            const totalProducts = content.get('productsCount');
            const availableProducts = <span>{` ${totalProducts}`}/{`${BROKER_FAVORITE_MAX_PRODUCT_SIZE} productos`}</span>
            const label = <span><span className="broker-watchlist-modal__list--radiotext">{`${name} -`}</span>{availableProducts}</span>
            return (
                <RadioButton
                    key={id}
                    disabled={totalProducts >= 25}
                    label={label}
                    value={id && id.toString()}
                />
            );
        });

        return (
            <div className="col-xs-12">
                <div className="broker-watchlist-modal__list--title">
                    {formatText('brokerWatchList-brokerWatchlist_existingListTitle')}
                </div>
                <div className="broker-watchlist-modal__list--subtitle">                    
                    {formatText('brokerWatchList-brokerWatchlist_existingListSubtitle')}
                </div>
                <div className="broker-watchlist-modal__list--content">
                    <div className="broker-watchlist-modal__list--radiocontent">
                        <RadioButtonGroup
                            name="watchlist"
                            idPrefix="watchlistPrefix"
                            onChange={this.handleListSelected}
                            selectedValue={listSelectedId}
                            errorState={false}
                        >
                            {radioContent}
                        </RadioButtonGroup>
                    </div>                    
                    <div className="broker-watchlist-modal__list--content-link">
                        <OKLink
                            id="createModalForNewList"
                            extraClass={disableLinkClassName}
                            inverse={false}
                            modifier="complementary"
                            onClick={handleNewListModal}
                            disabled={watchlistContent.size >= 10}
                        >
                            <FormattedText value="brokerWatchList-brokerWatchList_createListText" />
                        </OKLink>
                    </div>                    
                </div>
                <div className="broker-watchlist-modal__list--footer">
                    <div className="row">
                        <div className="col-xs-6">
                            <OKButton onClick={this.props.handleCancelForModal} modifier="link-ghost">
                                {formatText('brokerWatchList-brokerWatchList_cancelButton')}
                            </OKButton>
                        </div>
                        <div className="col-xs-6 text-right">
                            <OKButton onClick={this.props.handleContinueForExistingList} loading={false} disabled={!listSelectedId}>
                                {formatText('brokerWatchList-brokerWatchlist_nextButton')}
                            </OKButton>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    buildModalContent() {
        const { modifier } = this.props;
        switch (modifier) {
            case 'createNewList':
              return this.createModalForNewList();
            case 'addToList':
              return this.createModalForExistingList();
            default:
              return ;
          }
    }

    render() {
        const { isModalOpen } = this.props;
        return (
            <ModalCustom
                extraClass="col-xs-5"
                isOpen={isModalOpen}
                onRequestClose={this.props.handleCancelForModal}                
            >
                {this.buildModalContent()}
            </ModalCustom>
        );
    }
}

BrokerWatchlistModal.propTypes = {
    handleCancelForModal: PropTypes.func,
    handleContinueForExistingList: PropTypes.func,
    handleContinueForNewList: PropTypes.func,
    handleNewListModal: PropTypes.func,
    isModalOpen: PropTypes.bool.isRequired,
    listName: PropTypes.string,
    listSelectedId: PropTypes.string,
    modifier: PropTypes.string,
    onChangeListSelected: PropTypes.func,
    saveListName: PropTypes.func,
    watchlistContent: PropTypes.object.isRequired,
};

module.exports = BrokerWatchlistModal;
